export default __webpack_public_path__ + "img/allergy-vegan.1b3d304b20ced995a02d83a8d617ae98.svg";